import PropTypes from 'prop-types';
import React from 'react';
import Button from './Button';

const DownloadModal = (props) => {
  const {
    downloadReport,
    closeModal,
  } = props;

  return (
    <div className="operator-form">
      <div className="button-container">
        <Button text="app.button.no" onClick={closeModal} />
        <Button
          type="submit"
          text="app.button.yes"
          onClick={downloadReport}
        />
      </div>
    </div>
  );
};

DownloadModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  downloadReport: PropTypes.func.isRequired,
};

export default DownloadModal;
